const $ = require('jquery');
window.$ = window.jQuery = $;

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

import balloonPath from '../images-cp/balloon.gltf';

var BalonApp = function (e) {
    var t, n, a, i, o, r = $(e),
        d = {
            w: parseInt(r.width()),
            h: parseInt(r.height())
        },
        s = .001,
        c = new THREE.Clock;

    function w() {
        d = {
            w: parseInt(r.width(), 10),
            h: parseInt(r.height(), 10)
        }, n && (n.aspect = d.w / d.h, n.updateProjectionMatrix()), i && i.setSize(d.w, d.h)
    }

    function l() {
        if (t && t.update(), a) {
            i.render(a, n);
            var e = a.getObjectByName("balon");
            e && function (e) {
                if (e) {
                    var t = c.getDelta();
                    e.rotation.z += s * t
                }
            }(e)
        }
        requestAnimationFrame(l)
    }
    this.init = function () {
        (function () {
            try {
                var e = document.createElement("canvas");
                return !!window.WebGLRenderingContext && (e.getContext("webgl") || e.getContext("experimental-webgl"))
            } catch (e) {
                return !1
            }
        })() && (new GLTFLoader).load(balloonPath, function (e) {
            var t;
            $(".webgl-placeholder").css({
                visibility: "hidden"
            }), (i = new THREE.WebGLRenderer({
                antialias: !0,
                alpha: !0
            })).setClearColor(0, 0), i.setPixelRatio(window.devicePixelRatio), i.setSize(d.w, d.h), i.shadowMap.enabled = !0, i.shadowMap.type = THREE.PCFSoftShadowMap, a = new THREE.Scene, (t = new THREE.HemisphereLight(16777215, .8)).position.set(0, 10, 0), a.add(t), (t = new THREE.DirectionalLight(16777215, .8)).position.set(10, -6.666, .97), t.castShadow = !0, a.add(t), (t = new THREE.DirectionalLight(16777215, .66)).position.set(2.46, 6.588, -.449), t.castShadow = !0, a.add(t), (n = e.cameras[0]).aspect = d.w / d.h, n.position.z -= .3, n.fov = 50, n.updateProjectionMatrix(), a.add(e.scene), (o = e.scene.getObjectByName("balon")).rotation.x += .05, o.rotation.y -= .25, o.rotation.z += 1.735, r.append(i.domElement), window.addEventListener("resize", w, !1), s = .1, l()
        })
    }
};

window.jQuery(() => {
    var Baloon = new BalonApp('#intro__balloon');
    Baloon.init();
});
